import { BackendBaseModel, DateRangeSchema } from '@/utils';
import { z } from 'zod';
import { tagType } from './tags';

const GlobalTagBaseModel = BackendBaseModel.extend({
  type: tagType,
  name: z.string().min(1).max(16),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
});

export const GlobalTagsModel = GlobalTagBaseModel.array();

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const GlobalTagFormSchema = GlobalTagBaseModel.pick({
  type: true,
  name: true,
}).extend({
  period: DateRangeSchema.nullish(),
});

export const GlobalUpdateTagMutationParamsSchema = GlobalTagFormSchema.extend({
  id: z.string().uuid(),
});
